import { useCallback } from 'react';

export const useQueryParams = () => {
  const getQueryParam = useCallback((key: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  }, []);

  const setQueryParam = useCallback((key: string, value: string | null) => {
    const params = new URLSearchParams(window.location.search);
    
    if (value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
    
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }, []);

  const setMultipleQueryParams = useCallback((updates: Record<string, string | null>) => {
    const params = new URLSearchParams(window.location.search);
    
    Object.entries(updates).forEach(([key, value]) => {
      if (value === null) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    });
    
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }, []);

  return {
    getQueryParam,
    setQueryParam,
    setMultipleQueryParams
  };
};